import { itemsPerPage } from 'core/constants/pagination.constants';
import { EPromotionSearchMethod } from 'core/model/enums';
import { IPromotionsState } from './types';

export const SLICE_NAMESPACE = 'promotions';

export const initialState: IPromotionsState = {
  promotionList: {
    data: [],
    isLoading: false,
    pagination: {
      totalPages: 0,
      currentPage: 1,
      itemsPerPage,
      totalItems: 0,
    },
  },
  searchMethod: EPromotionSearchMethod.CODE,
  filters: {},
};
